module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mt-header', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "width": "100%",
      "z-index": "1000"
    },
    attrs: {
      "title": "实名认证"
    }
  }, [_c('div', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    },
    slot: "left"
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "70px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("证件照片")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "photo"
  }, [(_vm.portraitYrl) ? _c('img', {
    staticStyle: {
      "width": "237px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.portraitYrl,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.upPortraitBtn('on')
      }
    }
  }) : _c('div', {
    staticClass: "addImg",
    on: {
      "click": function($event) {
        return _vm.upPortraitBtn('on')
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "size": "50",
      "name": "plus"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#999"
    }
  }, [_vm._v("身份证人像面")])], 1), _vm._v(" "), _c('input', {
    ref: "upPortrait",
    staticClass: "upDataPart",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": "image/*",
      "id": "on"
    },
    on: {
      "change": function($event) {
        return _vm.portraitChange($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "photo"
  }, [(_vm.portraitYrlOther) ? _c('img', {
    staticStyle: {
      "width": "237px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.portraitYrlOther,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.upPortraitBtn('off')
      }
    }
  }) : _c('div', {
    staticClass: "addImg",
    on: {
      "click": function($event) {
        return _vm.upPortraitBtn('off')
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "size": "50",
      "name": "plus"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#999"
    }
  }, [_vm._v("身份证国徽面")])], 1), _vm._v(" "), _c('input', {
    ref: "upPortraitOther",
    staticClass: "upDataPart",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": "image/*",
      "id": "off"
    },
    on: {
      "change": function($event) {
        return _vm.portraitChange($event)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "standard"
  }, [_vm._v("\n    上传单个附件大小限制为4M，图片最小边不小于15px，最长边不超过4096px，格式为JPEG、JPG、PNG、BMP\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('van-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("提交审核")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06a2df57","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/realName/realName.vue
// module id = 1255
// module chunks = 1